import { c as _c } from "react/compiler-runtime";
import { Stack, SimpleGrid } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
interface SocialProofCardProps {
  description?: string;
  bgColor?: string;
  bgGradient?: string;
  color?: string;
  imageUrl?: string;
  cards?: React.ReactNode[];
  isGrid?: boolean;
  carouselProps?: CardCarouselProps;
}
const SocialProofCard: React.FC<SocialProofCardProps> = t0 => {
  const $ = _c(15);
  const {
    bgColor,
    bgGradient,
    cards,
    isGrid,
    carouselProps
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([1, 2, 3]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const breakpointColumns = t1;
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([5, 10]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const breakpointSpacing = t2;
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue(["column", "column", "column", "row"]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const breakpointDirection = t3;
  let t4;
  if ($[6] !== bgColor || $[7] !== bgGradient || $[8] !== breakpointColumns || $[9] !== breakpointDirection || $[10] !== breakpointSpacing || $[11] !== cards || $[12] !== carouselProps || $[13] !== isGrid) {
    t4 = isGrid ? <SimpleGrid bg={bgGradient} bgColor={bgColor} columns={breakpointColumns} gap={breakpointSpacing} width="full">{breakpointColumns === 1 ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
        top: false,
        bottom: MobileBottomControl
      }} {...carouselProps}>{cards?.map(_temp)}</CardCarousel> : cards?.map(_temp2)}</SimpleGrid> : <Stack align="stretch" bg={bgGradient} bgColor={bgColor} direction={breakpointDirection} gap={breakpointSpacing} justify="center" width="full">{breakpointDirection === "column" ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
        top: false,
        bottom: MobileBottomControl
      }} {...carouselProps}>{cards?.map(_temp3)}</CardCarousel> : cards?.map(_temp4)}</Stack>;
    $[6] = bgColor;
    $[7] = bgGradient;
    $[8] = breakpointColumns;
    $[9] = breakpointDirection;
    $[10] = breakpointSpacing;
    $[11] = cards;
    $[12] = carouselProps;
    $[13] = isGrid;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default SocialProofCard;
function _temp(card, index) {
  return <React.Fragment key={index}>{card}</React.Fragment>;
}
function _temp2(card_0, index_0) {
  return <React.Fragment key={index_0}>{card_0}</React.Fragment>;
}
function _temp3(card_1, index_1) {
  return <React.Fragment key={index_1}>{card_1}</React.Fragment>;
}
function _temp4(card_2, index_2) {
  return <React.Fragment key={index_2}>{card_2}</React.Fragment>;
}